

export enum AUTHOR_NAMES_EN {
	REBECCA_GREENWOOD = "Rebecca Greenwood",
	RICK_WARREN = "Rick Warren",
	CINDY_JACOBS = "Cindy Jacobs",
	AMAL_SAMUEL = "Amal Samuel",
	DINA_KHALED = "Dina Khaled",
	MARIAN_MAZOZA = "Marian Mazoza"
}

export enum AUTHOR_NAMES_AR {
	REBECCA_GREENWOOD = "ريبيكا غرينوود",
	RICK_WARREN = "ريك وارين",
	CINDY_JACOBS = "سيندي جاكوبس",
	AMAL_SAMUEL = "أمل صموئيل",
	DINA_KHALED = "دينا خالد",
	MARIAN_MAZOZA = "ماريان معزوز"
}